/**
 * @module expenseType
 * @description A list of expenseType
 */

export const expenseType = ['expense', 'voucher', 'reimburse'] as const;
export type ExpenseType = (typeof expenseType)[number];
